import { render, staticRenderFns } from "./App.vue?vue&type=template&id=6b9d6605"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./App.vue?vue&type=custom&index=0&blockType=meta&http-equiv=Content-Security-Policy&content=default-src%20'self'"
if (typeof block0 === 'function') block0(component)

export default component.exports